export default {
  buttons: {
    save: 'Guardar',
  },
  error_messages: {
    product_unavailable: 'Esgotado!',
  },
};
